import React from 'react'
import { useState } from 'react'
import { motion } from "framer-motion"
import { fadeInOut } from '../animations'

const LoginInput = ({ placeHolder, icon, inputState, inputStateFunc, type, isSignUp }) => {
    const [isForcus, setIsForcus] = useState(false)
    return (
        <motion.div {...fadeInOut}
        className={`flex items-center justify-center gap-4 bg-gray-100 backdrop-blur-md rounded-md w-full px-4 py-2 ${isForcus ? "shadow-md shadow-red-200" : "shadow-none"}`}>
            {icon}
            <input type={type} placeholder={placeHolder} className='w-full h-full bg-transparent text-headingColor text-lg font-semibold border-none outline-none'
                value={inputState}
                onChange={(e) => inputStateFunc(e.target.value)}
                onFocus={() => setIsForcus(true)}
                onBlur={() => setIsForcus(false)}
            />
        </motion.div>
    )
}

export default LoginInput